export const STEP_COUNT_PRIOR_TO_BUILDER = 1
